import { applyMiddleware, createStore, compose } from "redux";
import { persistStore } from "redux-persist";
import thunk from "redux-thunk";
// import { routerMiddleware } from "connected-react-router";
import reducers from "../reducers";

export var storeObj = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default (history) => {
  const store = createStore(
    reducers,
    compose(applyMiddleware(thunk /*, routerMiddleware(history)*/))
  );
  const persistor = persistStore(store);
  storeObj.store = store;
  return { persistor, store };
};
